import 'babel-polyfill';
import '@clearkit/one/dist/clearkit-one.css';
import './index.css';
import './css/submission/themes/default.css';

import * as Sentry from '@sentry/browser';
import ReactDOM from 'react-dom';
import { hot } from 'react-hot-loader';

import App from '~/components/App';
import ErrorHandler from '~/components/errorHandler';
import disableAnimationsWhileResizing from '~/lib/disableAnimationsWhileResizing';

Sentry.init({
  dsn: process.env.SENTRY_FRONTEND_DSN,
  env: process.env.NODE_ENV,
});

disableAnimationsWhileResizing();

const HotApp = hot(module)(App);

const renderApp = () => {
  return (
    <ErrorHandler>
      <HotApp />
    </ErrorHandler>
  );
};

ReactDOM.render(renderApp(), document.getElementById('root'));
